import { LineStrip } from './types';

export const drawLineStrip = (
  context: CanvasRenderingContext2D,
  vertices: LineStrip,
): void => {
  if (vertices.length >= 2) {
    context.beginPath();
    context.moveTo(vertices[0].x, vertices[0].y);
    for (let index = 1; index < vertices.length; index += 1) {
      context.lineTo(vertices[index].x, vertices[index].y);
    }
    context.stroke();
  }
};
